module.exports = __webpack_public_path__ + "assets/stripe.a933785d.svg";